import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillPortions: typeof valueTypeRenderers.chillPortions = {
  label: () => unitConverter.chillPortions().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillPortions().title(),
      render: (n) => unitConverter.chillPortions(n).valueAsString(),
    }),
}
